import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SignInPage from './pages/sign-in-page';
import AgreementPage from './pages/agreement-page';
import { routesConfig } from '@src/core/routes';
import VerifyEmailPage from './pages/verify-email-page';
import ResetPasswordPage from './pages/reset-password-page';
import VerifySuccessPage from './pages/verify-success-page';
import ActivateUserPage from './pages/activate-user-page';

const AuthFeature: React.FC = () => {
  return (
    <Routes>
      <Route path="/signIn" element={<SignInPage />} />
      <Route path="/agreement" element={<AgreementPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/verify-success" element={<VerifySuccessPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/activate" element={<ActivateUserPage />} />
      <Route path="*" element={<Navigate to={routesConfig.signIn} />} />
    </Routes>
  );
};

export default AuthFeature;